import { ApiArrayGetter, apiService } from "@/services/api/apiService";
import {
  IParamsHasDateInterval,
  IParamsHasOrder,
  IParamsHasPagination,
} from "@/services/api/ApiUniversalInterfaces";
import { enhanceObjectCopy, isNotNullObject } from "@/helpers/units";

export class LabOrder {
  "ord": number | null = null;
  "research_id": number | null = null;
  "orderid": string | null = null;
  "regdate": string | null = null;
  "status": string | null = null;
  "text_status": string | null = null;
  "material_id": string | null = null;
  "rnum": number | null = null;

  constructor(rawData: Record<string, unknown> = {}) {
    enhanceObjectCopy(rawData, this as Record<string, unknown>);
  }
}

interface IApiLabsOrdersParams
  extends IParamsHasDateInterval,
    IParamsHasPagination,
    IParamsHasOrder {}

export const API_Labs_orders = ApiArrayGetter<IApiLabsOrdersParams, LabOrder>(
  {
    endpoint: "/labs/orders",
    method: "get",
  },
  LabOrder
);
